import { useTranslation } from "react-i18next";
import { Button, Image, Popconfirm, Space, Tag } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import SearchDataIndex from "../../../context/share/SearchDataIndex";
import dayjs from "dayjs";
import { useMemo } from "react";

export function useColumnTable(handleDelete) {
  const getDataIndex = SearchDataIndex();
  const { t } = useTranslation("global");

  return useMemo(
    () => [
      {
        title: t("products.tableColumn.icon"),
        dataIndex: "icon",
        key: "icon",
        width: 80,
        render: (url) =>
          url ? (
            <Image
              src={url}
              alt={t("products.tableColumn.icon")}
              width={52}
              height={52}
              style={{ objectFit: "cover", borderRadius: 8 }}
              preview
            />
          ) : (
            <span style={{ color: "rgba(0,0,0,0.25)", fontSize: 12 }}>
              {t("products.noIcon")}
            </span>
          ),
      },
      {
        title: t("products.tableColumn.name"),
        dataIndex: "name",
        key: "name",
        ...getDataIndex("name"),
      },
      {
        title: t("products.tableColumn.description"),
        dataIndex: "description",
        key: "description",
        ellipsis: true,
      },
      {
        title: t("products.tableColumn.productType"),
        dataIndex: "type",
        key: "type",
        render: (text) => text ? <Tag>{text}</Tag> : "-",
        ...getDataIndex("type"),
      },
      {
        title: t("products.tableColumn.version"),
        dataIndex: "version",
        key: "version",
        render: (text) => text ? <Tag color="blue">{text}</Tag> : "-",
      },
      {
        title: t("products.tableColumn.createdAt"),
        dataIndex: "createdAt",
        key: "createdAt",
        render: (text) => (text ? dayjs(text).format("DD/MM/YYYY HH:mm") : "-"),
      },
      {
        title: t("products.tableColumn.updatedAt"),
        dataIndex: "updatedAt",
        key: "updatedAt",
        render: (text) => (text ? dayjs(text).format("DD/MM/YYYY HH:mm") : "-"),
      },
      {
        title: t("products.tableColumn.option"),
        dataIndex: "uuid",
        key: "option",
        fixed: "right",
        width: 160,
        render: (_, record) => (
          <Space>
            <Button
              type="text"
              icon={<EditOutlined />}
              href={`/products/${record.uuid}/edit`}
            >
              {t("device.edit")}
            </Button>
            <Popconfirm
              title={t("products.deleteConfirmTitle")}
              description={t("products.deleteConfirmContent")}
              onConfirm={() => handleDelete(record.uuid)}
              okText={t("global.yes")}
              cancelText={t("global.no")}
            >
              <Button type="text" danger icon={<DeleteOutlined />}>
                {t("device.delete")}
              </Button>
            </Popconfirm>
          </Space>
        ),
      },
    ],
    [t, getDataIndex, handleDelete],
  );
}
